module.exports = __webpack_public_path__ + "static/media/26238224_1536968339721835_210435423_o.cc5bb4f4.jpg";